import { useContext } from 'react';
import { css } from '@emotion/react';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';

// Styles
import { semiBoldFontWeight } from 'styles/global_defaults/fonts';
import { largeSpacing } from 'styles/global_defaults/scaffolding';

import MentoringProgramContext from './mentoring-program/context';
import {
  PILL_COLOR,
  PILL_MAX_WIDTH,
} from './mentoring-program/program-configuration/program-setup/alias-setting';

const participantPillStyles = (role: MentoringProgramRole) => css`
  height: ${largeSpacing}px;
  font-weight: ${semiBoldFontWeight};
  border-radius: ${largeSpacing / 2}px;
  color: ${PILL_COLOR[role].text};
  background-color: ${PILL_COLOR[role].background};
  max-width: ${PILL_MAX_WIDTH}px;
  div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

type ParticipantPillProps = {
  role: MentoringProgramRole;
};

const ParticipantPill = (props: ParticipantPillProps) => {
  const { role } = props;
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { programAlias } = mentoringProgram;
  const alias = role === MentoringProgramRole.MENTORSHIP_PROGRAM_MENTEE
    ? programAlias.mentee.capitalizedSingularized
    : programAlias.mentor.capitalizedSingularized;

  return (
    <div
      css={participantPillStyles(role)}
      className='pill d-flex align-items-center pr-2 pl-2 mr-1 text-small'
    >
      <div>{alias}</div>
    </div>
  )
};

export default ParticipantPill;
